import ApiService from './ApiService'

export const InsurersAndPackagesService = {

  baseURL: `${process.env.VUE_APP_HOMELAB_URL}`,

  getInsurers (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/insurers`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getPackages (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/packages`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getPackagesByEntity (entityId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/packages/${entityId}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  }
}

export const AppointmentService = {
  baseURL: `${process.env.VUE_APP_HOMELAB_URL}`,

  get (resource) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/appointments`, resource)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  store (entityId, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/entities/${entityId}/appointments`, data)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  update (entityId, appointmentId, data) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}/entities/${entityId}/appointments/${appointmentId}`, data)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },
  destroy (entityId, appointmentId) {
    return ApiService.delete(`${this.baseURL}/entities/${entityId}/appointments/${appointmentId}`)
  },
  downloadAppointments (params = {}) {
    return ApiService.blob(`${this.baseURL}/appointments/export`, params)
  },
  getStatistics (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/statistics`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  }
}

export const AppointmentStatusService = {

  baseURL: `${process.env.VUE_APP_HOMELAB_URL}`,

  store (appointmentId, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/appointments/${appointmentId}/statuses`, data)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  }
}

export const AppointmentFilesService = {

  baseURL: `${process.env.VUE_APP_HOMELAB_URL}`,

  store (appointmentId, formData) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/appointments/${appointmentId}/files`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  update (appointmentId, fileId, formData) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/appointments/${appointmentId}/files/${fileId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  download (appointmentId, fileId) {
    return new Promise((resolve, reject) => {
      ApiService.blob(`${this.baseURL}/appointments/${appointmentId}/files/${fileId}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  delete (appointmentId, fileId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/appointments/${appointmentId}/files/${fileId}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  }
}

export const AppointmentPaymentService = {

  baseURL: `${process.env.VUE_APP_HOMELAB_URL}`,

  updatePayment (entityId, appointmentId, data) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}/entities/${entityId}/appointments/${appointmentId}/payment`, data)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  }
}

export const AppointmentCommunicationService = {

  baseURL: `${process.env.VUE_APP_HOMELAB_URL}`,

  getMessages (appointmentId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/appointments/${appointmentId}/communication/messages`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  store (appointmentId, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/appointments/${appointmentId}/communication/messages`, data)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  }
}
